const castArray = (input) => {
  return Array.isArray(input) ? input : [input];
};
export {
  castArray
};
//# sourceMappingURL=castArray.js.map
